import '@vfde-brix/image-header/dist/styles.css';
import '@vfde-brix/highlight-badge/dist/styles.css';

import { createImageHeaderComponent } from '@vfde-brix/image-header';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-image-header');

for (let i = 0, x = elements.length; i < x; i += 1) {

    createImageHeaderComponent(elements[i], NO_PATTERN_BUSINESS_LOGIC);

}
